import { Password } from 'password-lib'
const passwordLib = new Password()

export function passwordRulesValidation (element) {
  return {
    ...passwordLib.validate.strength(element.value).rules
  }
}

export function passwordValidation (element) {
  return {
    ...passwordLib.validate.strength(element.value).rules,
    maxLength: element.value.length > 64,
    valueMissing: element.value.length === 0,
    valid: passwordLib.validate.strength(element.value).isValid
  }
}

export function togglePasswordVisibility (input) {
  if (input.$el.type === 'password') {
    input.$el.type = 'text'
    return true
  } else {
    input.$el.type = 'password'
    return false
  }
}

export function validatePasswordForm (validityObj) {
  return (validityObj.password.valid && validityObj.confirmPassword.valid) && !validityObj.passwordMismatch
}
